import React,{useState,useEffect, useContext} from 'react'
import Lottie from 'lottie-react'
import ReactTypingEffect from 'react-typing-effect'
import Footer from '../Components/Footer'
import workingAnimation from '../assets/working.json'
import Navbar from '../Components/Navbar'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Tabs, Accordion, Spinner } from 'flowbite-react';
import { HiAdjustments, HiClipboardList, HiUserCircle } from 'react-icons/hi';
import { MdDashboard,MdOfflinePin } from 'react-icons/md';
import {PiExamFill} from 'react-icons/pi'
import HandiCraftsAlumni from '../data/HandicraftsAlumni.js'
import axios from 'axios'
import AlumniTable from '../Components/AlumniTable'
import CourseVideos from '../Components/CourseVideos'
import OfflineClasses from '../Components/OfflineClasses'
import CourseEvaluation from '../Components/CourseEvaluation'
import CourseFAQ from '../Components/CourseFAQ'
import { UserIDContext } from '../Context/UserContext'
import LoadingPage from './LoadingPage'
import UserAddForm from '../Components/UserAddForm'
//<ReactTypingEffect speed={0.5} eraseSpeed={1} cursor={"_"} text={[""]}></ReactTypingEffect>
export default function GladiatorClass() {
  /**
   * https://i.postimg.cc/T1GDtZtZ/image-1.png
      https://i.postimg.cc/15mFw1nF/image-2.png
      https://i.postimg.cc/1Rc683tP/image-4.png
      https://i.postimg.cc/KjNgwJV4/image-5.png
   */
  const pathParam=useParams()
  const navigator = useNavigate()
  const switchPath = (pathname) => {
    navigator(pathname)
  }  
  const [loading,setLoading]=useState(true)
  const [gladiator,setGladiator]=useState({
    "gladiator_id": 3,
    "user_id": 9,
    "course_id": 53
})
  const [data,setData]=useState([])
  const [gladUsers,setGladUsers]=useState()
  const [lan, setLan] = useState('bangla')
  const userIDSaved=useContext(UserIDContext)
  const baseURL="https://mukti-backend-bd.onrender.com"

  const getData = async()=>{
      try{
        // const gladres=await axios.get(`${baseURL}/gladiator/user/${userIDSaved}`)
        // console.log(`${baseURL}/gladiator/user/${userIDSaved}`)
        // setGladiator(gladres.data)
        // console.log(gladiator)
        setLoading(false)
        const res = await axios.get(`${baseURL}/gau/${gladiator.gladiator_id}`)
        setData(res.data)
        console.log(res.data)
        
      }catch(e){
        console.log(e)
      }
      
    }
  
    useEffect(()=>{
      if (localStorage.getItem('language') === 'english') {
        setLan('english')
        } else {
        setLan('bangla')
        }
      getData()
    },[])
    
  return loading? <LoadingPage/> : (
    <div className="flex flex-row min-h-screen dark:bg-gray-900">
      <Navbar />
      <div class="bg-white mt-40 dark:bg-gray-900">
        <div class="gap-8 items-center py-8 px-4 mx-auto max-w-screen-2xl xl:gap-16 md:grid md:grid-cols-2 sm:py-16 lg:px-6">
          <div class="mt-4 md:mt-0">
            {lan=="english" && <h2 class="mb-4 text-center md:text-left text-5xl tracking-tight font-extrabold text-gray-900 dark:text-white"><span class="text-pink-600 dark:text-pink-500">User</span>Management</h2>}
            {lan=="english" && <p class="mb-6 text-center md:text-left  font-light text-gray-500 md:text-lg dark:text-gray-400">This page is dedicated towards managing our users by our gladiators</p>}

            {lan=="bangla" && <h2 class="mb-4 text-center md:text-left text-5xl tracking-tight font-extrabold text-gray-900 dark:text-white"><span class="text-pink-600 dark:text-pink-500">ব্যবহারকারী </span>ব্যবস্থাপনা</h2>}
            {lan=="bangla" && <p class="mb-6 text-center md:text-left  font-light text-gray-500 md:text-lg dark:text-gray-400">এই পৃষ্ঠাটি আমাদের গ্ল্যাডিয়েটরদের দ্বারা আমাদের ব্যবহারকারীদের পরিচালনার জন্য নিবেদিত</p>}
          </div>
        </div>

        <Tabs.Group
          aria-label="Full width tabs"
          style="fullWidth"
          className='px-8'
        >
          
          <Tabs.Item
            icon={MdDashboard}
            title="Add Users"
            className='border border-0'
          >
            {/**DASHBOARD */}
            <UserAddForm gladiator_id={gladiator.gladiator_id}/>
          </Tabs.Item>

        

          <Tabs.Item
            icon={PiExamFill}
            title="Added Users"
          >
            <AlumniTable/>
          </Tabs.Item>
          
        </Tabs.Group>



      </div>




    </div>

  )
}
